import { render } from "./TripsAddUpdateCopy.vue?vue&type=template&id=21d6ecf3&scoped=true"
import script from "./TripsAddUpdateCopy.vue?vue&type=script&lang=js"
export * from "./TripsAddUpdateCopy.vue?vue&type=script&lang=js"

import "./TripsAddUpdateCopy.vue?vue&type=style&index=0&id=21d6ecf3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d6ecf3"]])

export default __exports__